import { marketingConversationSchema } from "@redotech/redo-model/marketing/marketing-conversation/marketing-conversation-definition";
import { marketingMessageSchema } from "@redotech/redo-model/marketing/marketing-message/marketing-message-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getConversationById = {
  name: "getConversationById" as const,
  input: z.object({ id: zExt.objectId() }),
  output: z.object({
    conversation: marketingConversationSchema.nullable(),
    messages: z.array(marketingMessageSchema),
  }),
};
